import { useState, useEffect } from "react"
import styles from "./Maintenance.module.css"

// Simple icon components to replace Lucide icons
const SettingsIcon = () => (
  <svg width="40" height="40" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
    <circle cx="12" cy="12" r="3"></circle>
    <path d="M12 1v6m0 6v6m11-7h-6m-6 0H1m17-4a4 4 0 0 1-8 0 4 4 0 0 1 8 0zM7 21a4 4 0 0 1-8 0 4 4 0 0 1 8 0z"></path>
  </svg>
)

const ClockIcon = () => (
  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
    <circle cx="12" cy="12" r="10"></circle>
    <polyline points="12,6 12,12 16,14"></polyline>
  </svg>
)

const Maintenance = ({
  startTime = new Date("2025-07-30T14:00:00"),
  endTime = new Date("2025-07-30T16:00:00"),
  message
}) => {
  const [timeLeft, setTimeLeft] = useState({
    days: 0,
    hours: 0,
    minutes: 0,
    seconds: 0,
  })

  useEffect(() => {
    const calculateTimeLeft = () => {
      const now = new Date().getTime()
      const endTimeMs = endTime.getTime()
      const difference = endTimeMs - now

      if (difference > 0) {
        const days = Math.floor(difference / (1000 * 60 * 60 * 24))
        const hours = Math.floor((difference % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60))
        const minutes = Math.floor((difference % (1000 * 60 * 60)) / (1000 * 60))
        const seconds = Math.floor((difference % (1000 * 60)) / 1000)

        setTimeLeft({ days, hours, minutes, seconds })
      } else {
        setTimeLeft({ days: 0, hours: 0, minutes: 0, seconds: 0 })
      }
    }

    calculateTimeLeft()
    const timer = setInterval(calculateTimeLeft, 1000)

    return () => clearInterval(timer)
  }, [endTime])

 const formatTimeRange = () => {
  const startDate = startTime.toLocaleDateString("en-US", {
    year: "numeric",
    month: "long",
    day: "numeric",
  });

  const startTimeStr = startTime.toLocaleTimeString("en-US", {
    hour: "numeric",
    minute: "2-digit",
    hour12: true,
  });

  const endDate = endTime.toLocaleDateString("en-US", {
    year: "numeric",
    month: "long",
    day: "numeric",
  });

  const endTimeStr = endTime.toLocaleTimeString("en-US", {
    hour: "numeric",
    minute: "2-digit",
    hour12: true,
  });

  return `From: ${startDate}, ${startTimeStr} — To: ${endDate}, ${endTimeStr}`;
};


  return (
    <div className={styles.container}>
      <div className={styles.wrapper}>
        <div className={styles.card}>
        
          {/* Logo */}
            <div className={styles.logoIcon}>
            <img
  src={require("../../../assets/brand.png")}
  alt="Profile"
    
 style={{width:"100%",heigh:"100%"}}
  
  // className={SidebarStyle.profile_image}
/>   
            </div>

          {/* Maintenance Message */}
          <div className={styles.messageSection}>
            <h2 className={styles.mainMessage}>{message}</h2>
            <p className={styles.subMessage}>We'll be back online shortly. Thank you for your patience.</p>
          </div>

          {/* Countdown Timer */}
          <div className={styles.timerSection}>
            <div className={styles.timerGrid}>
              <div className={styles.timerCard}>
                <div className={styles.timerNumber}>{timeLeft.days.toString().padStart(2, "0")}</div>
                <div className={styles.timerLabel}>{timeLeft.days === 1 ? "Day" : "Days"}</div>
              </div>
              <div className={styles.timerCard}>
                <div className={styles.timerNumber}>{timeLeft.hours.toString().padStart(2, "0")}</div>
                <div className={styles.timerLabel}>{timeLeft.hours === 1 ? "Hour" : "Hours"}</div>
              </div>
              <div className={styles.timerCard}>
                <div className={styles.timerNumber}>{timeLeft.minutes.toString().padStart(2, "0")}</div>
                <div className={styles.timerLabel}>{timeLeft.minutes === 1 ? "Minute" : "Minutes"}</div>
              </div>
              <div className={styles.timerCard}>
                <div className={styles.timerNumber}>{timeLeft.seconds.toString().padStart(2, "0")}</div>
                <div className={styles.timerLabel}>{timeLeft.seconds === 1 ? "Second" : "Seconds"}</div>
              </div>
            </div>
          </div>

          {/* Maintenance Schedule */}
          <div className={styles.scheduleSection}>
            <div className={styles.scheduleHeader}>
              <ClockIcon />
              <h3 className={styles.scheduleTitle}>Maintenance Schedule</h3>
            </div>
            <p className={styles.scheduleTime}>{formatTimeRange()}</p>
          </div>

          {/* Additional Info */}
          <div className={styles.footerSection}>
            <p className={styles.footerText}>If you have any urgent questions, please contact our support team.</p>
          </div>
        </div>
      </div>
    </div>
  )
}

export default Maintenance